webpackJsonp([31,39,42],{

/***/ 1182:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1183);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("41205f32", content, true, {});

/***/ }),

/***/ 1183:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".native .Table2 .table[data-v-2ac98c66]{display:table;border-collapse:collapse;width:100%}.native .Table2 .td[data-v-2ac98c66],.native .Table2 .th[data-v-2ac98c66]{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.native .Table2 a[data-v-2ac98c66]{text-decoration:underline}.desktop .Table2 .table[data-v-2ac98c66],.smartphone .Table2 .table[data-v-2ac98c66],.tablet .Table2 .table[data-v-2ac98c66]{display:table;border-collapse:collapse;width:100%}.desktop .Table2 .td[data-v-2ac98c66],.desktop .Table2 .th[data-v-2ac98c66],.smartphone .Table2 .td[data-v-2ac98c66],.smartphone .Table2 .th[data-v-2ac98c66],.tablet .Table2 .td[data-v-2ac98c66],.tablet .Table2 .th[data-v-2ac98c66]{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.desktop .Table2 a[data-v-2ac98c66],.smartphone .Table2 a[data-v-2ac98c66],.tablet .Table2 a[data-v-2ac98c66]{text-decoration:underline}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/Table2/Table2.vue"],"names":[],"mappings":"AAmCA,wCACI,cAAe,AACf,yBAA0B,AAC1B,UAAY,CACf,AACD,0EAEI,sBAAuB,AACvB,kBAAmB,AACnB,cAAe,AACf,eAAoB,CACvB,AACD,mCACI,yBAA2B,CAC9B,AA6DD,6HAGI,cAAe,AACf,yBAA0B,AAC1B,UAAY,CACf,AACD,wOAMI,sBAAuB,AACvB,kBAAmB,AACnB,cAAe,AACf,eAAoB,CACvB,AACD,8GAGI,yBAA2B,CAC9B","file":"Table2.vue","sourcesContent":["\n.native[data-v-2ac98c66] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.native .Table2 .table[data-v-2ac98c66] {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n}\n.native .Table2 .th[data-v-2ac98c66],\n  .native .Table2 .td[data-v-2ac98c66] {\n    border: 1px solid #999;\n    text-align: center;\n    font-size: 1em;\n    font-weight: normal;\n}\n.native .Table2 a[data-v-2ac98c66] {\n    text-decoration: underline;\n}\n@media (min-width: 768px) {\n.native[data-v-2ac98c66] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n}\n@media (min-width: 1025px) {\n.native[data-v-2ac98c66] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n}\n.smartphone[data-v-2ac98c66],\n.tablet[data-v-2ac98c66],\n.desktop[data-v-2ac98c66] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.smartphone .Table2 .table[data-v-2ac98c66],\n  .tablet .Table2 .table[data-v-2ac98c66],\n  .desktop .Table2 .table[data-v-2ac98c66] {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n}\n.smartphone .Table2 .th[data-v-2ac98c66],\n  .smartphone .Table2 .td[data-v-2ac98c66],\n  .tablet .Table2 .th[data-v-2ac98c66],\n  .tablet .Table2 .td[data-v-2ac98c66],\n  .desktop .Table2 .th[data-v-2ac98c66],\n  .desktop .Table2 .td[data-v-2ac98c66] {\n    border: 1px solid #999;\n    text-align: center;\n    font-size: 1em;\n    font-weight: normal;\n}\n.smartphone .Table2 a[data-v-2ac98c66],\n  .tablet .Table2 a[data-v-2ac98c66],\n  .desktop .Table2 a[data-v-2ac98c66] {\n    text-decoration: underline;\n}\n.tablet[data-v-2ac98c66],\n.desktop[data-v-2ac98c66] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.desktop[data-v-2ac98c66] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Table2.l.scss": 1185,
	"./Table2.m.scss": 1187,
	"./Table2.s.scss": 1189,
	"./Table2.scss": 1191
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1184;

/***/ }),

/***/ 1185:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1186);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1186:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1187:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1188);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1188:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1189:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1190);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1190:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".Table2 .table{display:table;border-collapse:collapse;width:100%}.Table2 .td,.Table2 .th{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.Table2 a{text-decoration:underline}", ""]);

// exports


/***/ }),

/***/ 1191:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1192);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1192:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".Table2 .table{display:table;border-collapse:collapse;width:100%}.Table2 .td,.Table2 .th{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.Table2 a{text-decoration:underline}", ""]);

// exports


/***/ }),

/***/ 1193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contents)?[_c('div',{class:['component', _vm.previewSize],style:(_vm.hideAll ? 'display:none' : '')},[_c('div',{on:{"click":function($event){_vm.isEditing = !_vm.isEditing}}},[_c('section',{class:_vm.sectionClassArray,style:(_vm.sectionStyle)},[_c('div',{class:_vm.containerClassArray},[_c('h2',{staticClass:"Table2-h2"},[_vm._v(_vm._s(_vm.contents.heading.text))]),_vm._v(" "),_c('p',{staticClass:"Table2-p"},[_vm._v(_vm._s(_vm.contents.paragraph.text))]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',{staticClass:"thead",style:(_vm.getCustomHeadColorStyle)},[_c('tr',{staticClass:"tr"},[_vm._l((_vm.contents.table[0]),function(row,rowIndex){return [(row.href)?[_c('th',{staticClass:"th px2 py1"},[_c('a',{staticClass:"inline-block theme-accent-color text-decoration-underline",style:(_vm.getCustomLinkColorStyle),attrs:{"href":row.href}},[_vm._v(_vm._s(row.text))])])]:[_c('th',{staticClass:"th px2 py1"},[_vm._v(_vm._s(row.text))])]]})],2)]),_vm._v(" "),_c('tbody',{staticClass:"tbody",style:(_vm.getCustomBodyColorStyle)},[_vm._l((_vm.contents.table),function(row,rowIndex){return [(rowIndex > 0)?[_c('tr',{staticClass:"tr",style:(rowIndex % 2 === 0 ? _vm.getCustomAltColorStyle : '')},[_vm._l((row),function(column,columnIndex){return [(column.href)?[_c('td',{staticClass:"td px2 py1"},[_c('a',{staticClass:"inline-block theme-accent-color text-decoration-underline",style:(_vm.getCustomLinkColorStyle),attrs:{"href":column.href}},[_vm._v(_vm._s(column.text))])])]:[_c('td',{staticClass:"td px2 py1"},[_vm._v(_vm._s(column.text))])]]})],2)]:_vm._e()]})],2)]),_vm._v(" "),_c('p',{staticClass:"Table2-note"},[_vm._v(_vm._s(_vm.contents.note.text))])])])])]),_vm._v(" "),_c('el-form',{class:['component-contents-form', ' p2', _vm.lock ? 'hide' : _vm.isEditing ? 'show' : 'hide'],attrs:{"model":_vm.contents}},[_c('h2',[_vm._v("コンポーネントのコンテンツを編集")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"テーブルの見出し","label-width":_vm.labelWidth}},[_c('el-input',{attrs:{"type":"textarea","autosize":{minRows:2},"auto-complete":"off"},model:{value:(_vm.contents.heading.text),callback:function ($$v) {_vm.$set(_vm.contents.heading, "text", $$v)},expression:"contents.heading.text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"テーブルの説明","label-width":_vm.labelWidth}},[_c('el-input',{attrs:{"type":"textarea","autosize":{minRows:2},"auto-complete":"off"},model:{value:(_vm.contents.paragraph.text),callback:function ($$v) {_vm.$set(_vm.contents.paragraph, "text", $$v)},expression:"contents.paragraph.text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"テーブルの補足説明","label-width":_vm.labelWidth}},[_c('el-input',{attrs:{"type":"textarea","autosize":{minRows:2},"auto-complete":"off"},model:{value:(_vm.contents.note.text),callback:function ($$v) {_vm.$set(_vm.contents.note, "text", $$v)},expression:"contents.note.text"}})],1),_vm._v(" "),_c('div',[_c('table',{staticClass:"table"},[_c('thead',{staticClass:"thead"},[_c('tr',{staticClass:"tr"},[_c('th',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){_vm.deleteRow(0)}}})],1),_vm._v(" "),_vm._l((_vm.contents.table[0]),function(row,rowIndex){return [_c('th',{staticClass:"th"},[_c('div',{staticClass:"flex column"},[_c('el-input',{model:{value:(_vm.contents.table[0][rowIndex].text),callback:function ($$v) {_vm.$set(_vm.contents.table[0][rowIndex], "text", $$v)},expression:"contents.table[0][rowIndex].text"}}),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"リンク先URL"},model:{value:(_vm.contents.table[0][rowIndex].href),callback:function ($$v) {_vm.$set(_vm.contents.table[0][rowIndex], "href", $$v)},expression:"contents.table[0][rowIndex].href"}})],1)])]}),_vm._v(" "),_c('th',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-circle-plus-outline"},on:{"click":function($event){_vm.addRow(0)}}})],1)],2)]),_vm._v(" "),_c('tbody',{staticClass:"tbody"},[_vm._l((_vm.contents.table),function(row,rowIndex){return [(rowIndex > 0)?[_c('tr',{staticClass:"tr"},[_c('td',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete"},on:{"click":function($event){_vm.deleteRow(rowIndex)}}})],1),_vm._v(" "),_vm._l((row),function(column,columnIndex){return [_c('td',{staticClass:"td"},[_c('div',{staticClass:"flex column"},[_c('el-input',{model:{value:(_vm.contents.table[rowIndex][columnIndex].text),callback:function ($$v) {_vm.$set(_vm.contents.table[rowIndex][columnIndex], "text", $$v)},expression:"contents.table[rowIndex][columnIndex].text"}}),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"リンク先URL"},model:{value:(_vm.contents.table[rowIndex][columnIndex].href),callback:function ($$v) {_vm.$set(_vm.contents.table[rowIndex][columnIndex], "href", $$v)},expression:"contents.table[rowIndex][columnIndex].href"}})],1)])]}),_vm._v(" "),_c('td',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-circle-plus-outline"},on:{"click":function($event){_vm.addRow(rowIndex)}}})],1)],2)]:_vm._e()]})],2)])]),_vm._v(" "),_c('el-form-item',{staticClass:"mt5",attrs:{"label":"コンポーネント配置順序","label-width":_vm.labelWidth}},[_c('el-input-number',{attrs:{"controls-position":"right","min":1,"max":_vm.positionMax},model:{value:(_vm.newPosition),callback:function ($$v) {_vm.newPosition=$$v},expression:"newPosition"}}),_c('span',{staticClass:"pl4"},[_vm._v("1から"+_vm._s(_vm.positionMax)+"まで")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"テーブルヘッダーの背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.head.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.head, "isCustom", $$v)},expression:"contents.head.isCustom"}},[_vm._v("テーブルヘッダー（1行目）の背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.head.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.head.color),callback:function ($$v) {_vm.$set(_vm.contents.head, "color", $$v)},expression:"contents.head.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.head.color))])],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"テーブルボディの背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.body.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.body, "isCustom", $$v)},expression:"contents.body.isCustom"}},[_vm._v("テーブルボディ（2行目以降）の背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.body.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.body.color),callback:function ($$v) {_vm.$set(_vm.contents.body, "color", $$v)},expression:"contents.body.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.body.color))])],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"テーブルボディの交互の背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.alt.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.alt, "isCustom", $$v)},expression:"contents.alt.isCustom"}},[_vm._v("テーブルボディ（2行目以降）の交互の背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.alt.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.alt.color),callback:function ($$v) {_vm.$set(_vm.contents.alt, "color", $$v)},expression:"contents.alt.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.alt.color))])],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"リンクの文字色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.link.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.link, "isCustom", $$v)},expression:"contents.link.isCustom"}},[_vm._v("リンクの文字色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.link.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.link.color),callback:function ($$v) {_vm.$set(_vm.contents.link, "color", $$v)},expression:"contents.link.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.link.color))])],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド上下の余白","label-width":_vm.labelWidth}},[_c('el-slider',{attrs:{"step":1,"min":0,"max":10},model:{value:(_vm.contents.padding.y),callback:function ($$v) {_vm.$set(_vm.contents.padding, "y", $$v)},expression:"contents.padding.y"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"スライド背景色","label-width":_vm.labelWidth}},[_c('div',[_c('el-checkbox',{model:{value:(_vm.contents.bg.isCustom),callback:function ($$v) {_vm.$set(_vm.contents.bg, "isCustom", $$v)},expression:"contents.bg.isCustom"}},[_vm._v("スライドの背景色を指定する")])],1),_vm._v(" "),_c('div',{staticClass:"items-center",style:({display: _vm.contents.bg.isCustom ? 'flex' : 'none'})},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.contents.bg.color),callback:function ($$v) {_vm.$set(_vm.contents.bg, "color", $$v)},expression:"contents.bg.color"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.contents.bg.color))])],1)]),_vm._v(" "),_c('div',{staticClass:"component-contents-controller flex justify-end items-center"},[_c('component-form-footer',{on:{"delete":function($event){_vm.deleteComponent()},"cancel":function($event){_vm.isEditing = false},"update":function($event){_vm.updateComponent()}}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e587aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'component-form-footer': __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__["default"]
  },
  data: function data() {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    };
  },

  props: {
    index: { type: Number, default: null },
    bus: { type: Object, default: null },
    positionMax: { type: Number, default: null },
    component: { type: Object, default: null },
    components: { type: Array, default: null },
    hideAll: { type: Boolean, default: false },
    lock: { type: Boolean, default: false },
    previewSize: { type: String, default: 'native' },
    inPreview: { type: Boolean, default: false }
  },
  computed: {
    contents: {
      get: function get() {
        return this.component.contents;
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    meta: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].components[this.component.id].meta;
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    },
    sectionId: {
      get: function get() {
        return this.componentId(this);
      }
    },
    sectionClass: {
      get: function get() {
        return this.meta.file + ' ' + this.meta.file + '-' + this._uid + ' ' + (this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + ' slide';
      }
    },
    sectionClassArray: {
      get: function get() {
        return [this.meta.file, 'slide', 'theme-base-bg-color'];
      }
    },
    sectionStyle: {
      get: function get() {
        return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
      }
    },
    containerClass: {
      get: function get() {
        return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '');
      }
    },
    containerClassArray: {
      get: function get() {
        return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y];
      }
    },
    gridClass: {
      get: function get() {
        return 'grid grid-mx' + this.contents.layout.margin + ' grid-my' + this.contents.layout.margin + ' grid-1-' + this.contents.layout.s + ' grid-1-' + this.contents.layout.m + '-m grid-1-' + this.contents.layout.l + '-l';
      }
    },
    gridClassArray: {
      get: function get() {
        return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'];
      }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function componentId(that) {
      return that.component ? that.component.meta.file + '-' + that._uid : that.meta.file + '-' + that._uid;
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function getPageById(id) {
      return this.pages.find(function (page) {
        return page.id === id;
      });
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function getSubPagesById(id) {
      return this.pages.filter(function (page) {
        return page.parent === id && page.status === 'publish';
      });
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function updateComponent() {
      if (false) console.log('Running updateComponent of ' + this.name + '...');

      this.component.html = this.generateHtml(this.component.contents);
      this.component.css = this.generateCss(this.component.contents);
      this.$emit('update', { component: this.component, newPosition: this.newPosition });
      this.isEditing = false;
    },

    updateComponentUid: function updateComponentUid() {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (false) console.log('%c_uid has been changed: ' + this.component._uid + ' -> ' + this._uid, 'color:blue');
        this.bus.$emit('uid-updated', this);
        this.component._uid = this._uid;
        if (false) console.log('%c_uid has been updated: this.component._uid = ' + this.component._uid, 'color:teal');
      }
    },

    updateComponentAndUid: function updateComponentAndUid() {
      this.updateComponentUid();
      this.updateComponent();
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function deleteComponent() {
      this.$emit('delete');
      this.isEditing = false;
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function created() {
    if (!this.component._uid) this.component._uid = this._uid;
    if (this.component.uid) delete this.component.uid;
    this.updateComponent();
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function mounted() {
    this.$emit('mounted');
    this.bus.$on('update-child', this.updateComponentAndUid);
  }
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table2_vue__ = __webpack_require__(817);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ac98c66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table2_vue__ = __webpack_require__(1193);
function injectStyle (ssrContext) {
  __webpack_require__(1182)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ac98c66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ac98c66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-form-footer',
  methods: {
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onUpdate: function onUpdate() {
      this.$emit('update');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("727fe8b8", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ComponentFormFooter.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.onDelete()}}},[_vm._v("削除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdate}},[_vm._v("適用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mixins_ComponentBase__ = __webpack_require__(132);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-2',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_mixins_ComponentBase__["default"]],
  data: function data() {
    return {
      labelWidth: '210px'
    };
  },
  computed: {
    getCustomHeadColorStyle: function getCustomHeadColorStyle() {
      return this.contents.head.isCustom ? 'background-color:' + this.contents.head.color : '';
    },
    getCustomHeadColorClass: function getCustomHeadColorClass() {
      return this.contents.head.isCustom ? this.meta.file + '-' + this._uid + '-thead-bg' : '';
    },
    getCustomBodyColorStyle: function getCustomBodyColorStyle() {
      return this.contents.body.isCustom ? 'background-color:' + this.contents.body.color : '';
    },
    getCustomBodyColorClass: function getCustomBodyColorClass() {
      return this.contents.body.isCustom ? this.meta.file + '-' + this._uid + '-tbody-bg' : '';
    },
    getCustomAltColorStyle: function getCustomAltColorStyle() {
      return this.contents.alt.isCustom ? 'background-color:' + this.contents.alt.color : '';
    },
    getCustomAltColorClass: function getCustomAltColorClass() {
      return this.contents.alt.isCustom ? this.meta.file + '-' + this._uid + '-talt-bg' : '';
    },
    getCustomLinkColorStyle: function getCustomLinkColorStyle() {
      return this.contents.link.isCustom ? 'color:' + this.contents.link.color : '';
    },
    getCustomLinkColorClass: function getCustomLinkColorClass() {
      return this.contents.link.isCustom ? this.meta.file + '-' + this._uid + '-link-color' : 'theme-accent-color';
    },
    getCustomBgColorStyle: function getCustomBgColorStyle() {
      return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
    },
    getCustomBgColorClass: function getCustomBgColorClass() {
      return this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color';
    },
    src: function src() {}
  },
  methods: {
    addRow: function addRow(index) {
      this.contents.table.splice(index + 1, 0, [{ text: '', href: '' }, { text: '', href: '' }]);
    },
    deleteRow: function deleteRow(index) {
      this.contents.table.splice(index, 1);
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function generateHtml(contents) {
      var _this = this;

      // theadの中身
      var tableHead = contents.table.reduce(function (acc, row, rowIndex) {
        if (rowIndex > 0) return acc;
        var innerTr = row.reduce(function (prev, column, columnIndex) {
          var innerCell = column.href ? '<a class="inline-block text-decoration-underline ' + _this.getCustomLinkColorClass + '" href="' + column.href + '">' + column.text + '</a>' : column.text;
          return prev + ('<th class="th px2 py1">' + innerCell + '</th>');
        }, '');
        return '<tr class="tr">' + innerTr + '</tr>';
      }, '');

      // tbodyの中身
      var tableBody = contents.table.reduce(function (acc, row, rowIndex) {
        if (rowIndex === 0) return acc;
        var innerTr = row.reduce(function (prev, column, columnIndex) {
          var innerCell = column.href ? '<a class="inline-block text-decoration-underline ' + _this.getCustomLinkColorClass + '" href="' + column.href + '">' + column.text + '</a>' : column.text;
          return prev + ('<td class="td px2 py1">' + innerCell + '</td>');
        }, '');
        return acc + ('<tr class="tr">' + innerTr + '</tr>');
      }, '');

      return ('\n      <section id="' + this.sectionId + '" class="' + this.sectionClass + '">\n        <div class="' + this.containerClass + '">\n          <h2 class="' + this.meta.file + '-h2">' + contents.heading.text + '</h2>\n          <p class="' + this.meta.file + '-p">' + contents.paragraph.text + '</p>\n          <table class="table">\n            <thead class="thead">' + tableHead + '</thead>\n            <tbody class="tbody">' + tableBody + '</tbody>\n          </table>\n          <p class="' + this.meta.file + '-note">' + contents.note.text + '</p>\n        </div>\n      </section>\n      ').trim().replace(/>\s+</g, '><');
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function generateCss(contents) {
      var layout = __webpack_require__(1184)("./" + this.meta.file + '.scss');
      var theme = '';
      if (contents.head.isCustom) theme += '.' + this.meta.file + '-' + this._uid + ' thead {' + this.getCustomHeadColorStyle + '}';
      if (contents.body.isCustom) theme += '.' + this.meta.file + '-' + this._uid + ' tbody {' + this.getCustomBodyColorStyle + '}';
      if (contents.alt.isCustom) theme += '.' + this.meta.file + '-' + this._uid + ' tbody tr:nth-child(even) {' + this.getCustomAltColorStyle + '}';
      if (contents.link.isCustom) theme += '.' + this.meta.file + '-' + this._uid + '-link-color {' + this.getCustomLinkColorStyle + '}';
      if (contents.bg.isCustom) theme += '.' + this.meta.file + '-' + this._uid + ' {' + this.getCustomBgColorStyle + '}';
      return { layout: layout, theme: theme };
    }
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.posts.length) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this.$store.dispatch('wordpress/posts/fetch');

            case 3:

              // migration
              if (!this.contents.note) this.contents.note = { text: '' };
              if (!this.contents.padding) this.contents.padding = { y: 4 };

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }()
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/31.d742f6b581b68c184c50.js